






















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Banner extends Vue {
  @Prop(Array) readonly navigation!: any
  mounted () {
    console.log('navigation', this.navigation)
  }
}
